import React, { useContext, useState } from "react";
import Swal from "sweetalert2";
import errorRedIcon from "../../images/errorRedIcon.png";
import { UrlContext } from "../../contexts/UrlContext";

export default function ProjectExpertDelete({
  expert_id,
  project_id,
  setHideDeletedRow,
  tableData,
  setTableData,
  backupData,
  setBackupData,
}) {
  const [deletePopup, setDeletePopup] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const deleteProjExpertHandler = () => {
    const url = `${API_URL}delete-project-expert`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ expertID: expert_id, projectID: project_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Success",
            showConfirmButton: false,
            timer: 1500,
          });
          setDeletePopup(false);
          setTableData(prevData => prevData.filter(data => data.expert.ID !== expert_id));
          setBackupData(prevData => prevData.filter(data => data.expert.ID !== expert_id));
          // setHideDeletedRow(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          setDeletePopup(false);
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  return (
    <>
      <div className="delete-prj-icon">
        <i
          className="fa fa-trash"
          title="Delete from project"
          onClick={() => setDeletePopup(true)}
        />
      </div>

      {deletePopup && (
        <div className="prjdetails-delete-popup-wrapper">
          <div className="tab-pane fade show prjdetails-deleteEx-div">
            <div>
              <center>
                <img src={errorRedIcon} width="50px" height="50px" alt="" />
                <p>Expert will be removed from this project!</p>
                <br />
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => setDeletePopup(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: 6 }}
                  onClick={() => deleteProjExpertHandler()}
                >
                  Continue
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
